<template>
  <section>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <b-modal v-model="show" :width="1000" scroll="keep" :on-cancel="closeModal">
      <div class="modal-widget" id="#create_device_cotainer">
        <div class="modal-title">
          <h2 class="title">Asignar permisos</h2>
        </div>
        <div class="modal-body">
          <div class="form-container">
            <div class="columns mb-2">
              <div class="column">
                <CompanySelector v-model="company" />
              </div>
              <div class="column">
                <b-field label="Dispositivo *">
                  <b-select
                    placeholder="Disposiitvo"
                    expanded
                    v-model="deviceId"
                    name="deviceId"
                  >
                    <option
                      v-for="option in devicesList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column"></div>
            </div>
          </div>
          <div class="apps-permises-container">
            <div class="columns device-modules mt-1">
              <div class="columns pt-3 pb-3 flex-center" v-if="loadingModules">
                <Loader />
              </div>
              <div class="columns container" v-if="!loadingModules">
                <div
                  class="column"
                  v-for="(moduleGroup, moduleIndex) in moduleGroups"
                  :value="moduleGroup.app.code"
                  :key="moduleGroup.app.code"
                  :id="moduleGroup.app.code"
                >
                  <div class="group-container">
                    <div class="group-header mt-2">
                      <div class="check-group-header">
                        {{ moduleGroup.app.title }}
                      </div>
                      <div class="options">
                        <vs-button
                          color="primary"
                          icon="add"
                          class="btn-option btn-add-discount"
                          title="Agregar descuento"
                          @click="addDiscount"
                          v-if="moduleGroup.app.url === 'discount'"
                        ></vs-button>
                        <vs-button
                          color="success"
                          icon="settings"
                          class="btn-option btn-config-discount"
                          title="Configuración"
                          @click="configEntryOut"
                          v-if="moduleGroup.app.url === 'entry_out'"
                        ></vs-button>
                      </div>
                    </div>
                    <div class="group-body">
                      <ul class="activities-container">
                        <li
                          class="activity-item"
                          v-for="(
                            activity, activityIndex
                          ) in moduleGroup.activities"
                          :value="activity.code"
                          :key="activityIndex"
                          :id="activity.code"
                        >
                          <vs-checkbox
                            class="justify-content-start checkbox-item"
                            :title="activity.title"
                            v-on:change="onChangeCheckModule(activity)"
                            :disabled="!activity.activated"
                            v-if="activity.actionType != 'GE'"
                            v-model="
                              $data.moduleGroups[moduleIndex].activities[
                                activityIndex
                              ].selected
                            "
                          >
                            {{ activity.title }}
                          </vs-checkbox>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column text-right">
              <vs-button
                color="danger"
                type="filled"
                class="pl-5 pr-5"
                icon="close"
                @click="closeModal"
                >Cancelar</vs-button
              >
              <vs-button
                color="success"
                class="ml-3 pl-5 pr-5"
                icon="save"
                type="filled"
                @click="saveConfiguration"
                :disabled="validate()"
              >
                Guardar
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import CompanySelector from "../../../components/Shared/CompanySelector";
import Loader from "../../../components/Shared/Loader.vue";
import { ROUTES } from "../../../global/api_routes";
import { TOAST_TYPES, configToast } from "../../../global/toast";
import { STATUS } from "../../../global/constants";
import { validArray, sortByKeyName } from "../../../global/utils";
import { validator } from "../../../global/validator";
import { ActivityType } from "../../../global/constants";

export default {
  components: { CompanySelector, Loader },
  data: () => ({
    isLoading: false,
    activities: [],
    loadingModules: false,
    show: false,
    company: null,
    device: null,
    deviceName: null,
    imei: null,
    graceTime: null,
    resolution: null,
    technology: null,
    initialValue: null,
    technologies: [],
    devicesList: [],
    resolutions: [],
    moduleGroups: [],
    deviceActivities: [],
    deviceId: null,
  }),
  watch: {
    moduleGroups: function () {
      if (
        !this.loadingModules ||
        this.moduleGroups === null ||
        !validArray(this.moduleGroups, 1) ||
        !this.deviceId
      ) {
        this.loadingModules = false;
        return;
      }
      this.findDeviceActivities();
    },
    company: function (company) {
      if (!company) {
        return;
      }
      this.loadingModules = true;
      this.getModuleGroups(company);
      this.getListDevices(company);
    },
  },
  mounted() {},
  methods: {
    configEntryOut() {
      let routeData = this.$router.resolve({
        name: "Editar Dispositivo",
        query: { code: this.deviceId },
      });
      window.open(routeData.href, "_blank");
    },
    addDiscount() {
      window.open("/parkapp/view/discounts");
    },
    getListDevices(companyId) {
      this.isLoading = true;
      this.$http
        .get(
          `${ROUTES.DASHBOARD.CONFIG_DEVICES.GET_COMPANY_DEVICES_LIST}?companyId=${companyId}`
        )
        .then(({ data }) => {
          if (data.code > 0) {
            this.devicesList = data.info;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onChangeCheckModule(object) {
      if (!object.activated) {
        this.toast(
          "No tienes permisos para hacer esta modificación",
          TOAST_TYPES.ERROR
        );
        this.closeModal();
        return;
      }
      if (object.activities) {
        const list = [...this.moduleGroups];
        this.moduleGroups = list.map((group) => {
          if (group.app.code == object.app.code) {
            group.timestamp = new Date().getTime();
            group.activities = group.activities.map((activity) => {
              return { ...activity, deleted: !object.selected };
            });
          }
          return group;
        });
        return;
      }
    },
    setData({ deviceId, company }) {
      this.deviceId = deviceId;
      this.company = company;
      this.getModuleGroups(company);
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#create_device_cotainer");
      return instance.open(message, type);
    },
    validate() {
      const rules = [{ field: "company" }, { field: "deviceId" }];
      const { result, errors } = validator(this, rules);
      const activities = this.moduleGroups.filter(
        (m) => m.activities.filter((a) => a.selected).length > 0
      );
      return !result && activities.length === 0;
    },
    replaceActivities({ app, actionType, keyName, initialsText = null }) {
      const index = app.activities.findIndex(
        (activity) =>
          activity.actionType === actionType && !activity.originalActivity
      );
      const activity = index >= 0 ? app.activities[index] : null;
      let list = [];
      if (index >= 0 && Array.isArray(activity[keyName])) {
        app.activities.splice(index, 1);
      }
      if (!initialsText && activity && actionType === activity.actionType) {
        app.activities = app.activities.concat(
          activity[keyName].map((item) => {
            return {
              ...item,
              keyListName: keyName,
              originalActivity: activity,
            };
          })
        );
      }
      if (Array.isArray(initialsText) && activity) {
        initialsText.forEach((initText) => {
          list = list.concat(
            activity[keyName].map((item) => {
              return {
                ...item,
                keyListName: keyName,
                listNameType: initText.code,
                title: `${initText.text}${initText.text ? " " : ""}${
                  item.title
                }`,
                originalActivity: activity,
              };
            })
          );
        });
      }
      app.activities = sortByKeyName(app.activities.concat(list), "title");
    },
    parseModules(list = []) {
      list.forEach((app) => {
        this.replaceActivities({
          app,
          actionType: ActivityType.VOUCHER,
          keyName: "vouchers",
          initialsText: [{ code: "vo", text: "" }],
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.VEHICLE_TYPES,
          keyName: "vehicleTypes",
          initialsText: [
            { code: "entry", text: "Ingreso de" },
            { code: "out", text: "Salida de" },
          ],
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.PAY_TYPES,
          keyName: "vehicleTypes",
          initialsText: [{ code: "pay", text: "Pago de " }],
        });
      });
      return list;
    },
    getModuleGroups(companyId) {
      this.loadingModules = true;
      this.$http
        .get(
          `${ROUTES.DASHBOARD.CONFIG_DEVICES.GET_MODULE_GROUPS}?companyId=${companyId}`
        )
        .then(({ data }) => {
          if (data.code > 0) {
            this.moduleGroups = this.parseModules(data.info);
          }
        })
        .finally(() => {
          this.loadingModules = false;
        });
    },
    getDeviceData() {
      const deviceActivities = [];
      this.moduleGroups.forEach((moduleGroup) => {
        moduleGroup.activities.forEach((activity) => {
          const deleted = activity.saved && !activity.selected;
          if (activity.selected || deleted) {
            let deviceActivityIndex = deviceActivities.findIndex((item) => {
              const activityCode = activity.originalActivity
                ? activity.originalActivity.code
                : activity.code;
              return item.activity.code == activityCode;
            });

            const resumeActivity = {
              keyListName: activity.keyListName,
              listNameType: activity.listNameType,
              codeListItem: activity.code,
              selected: !deleted,
              enable: true,
            };

            let deviceActivity = {
              device: {
                code: this.deviceId,
              },
              activity: {
                code: activity.originalActivity
                  ? activity.originalActivity.code
                  : activity.code,
              },
              status: deleted ? STATUS.DISABLED : STATUS.ACTIVE,
              purchasedModule: [resumeActivity],
            };
            if (deviceActivityIndex >= 0) {
              deviceActivities[deviceActivityIndex].status = STATUS.ACTIVE;
              if (!deleted) {
                deviceActivities[deviceActivityIndex].purchasedModule.push(
                  resumeActivity
                );
              }
            } else {
              deviceActivities.push(deviceActivity);
            }
          }
        });
      });

      deviceActivities.forEach((deviceActivity) => {
        deviceActivity.purchasedModule = JSON.stringify(
          deviceActivity.purchasedModule
        );
      });

      return {
        code: this.deviceId,
        company: { code: this.company },
        deviceActivities: deviceActivities,
      };
    },
    saveConfiguration() {
      const obj = this.getDeviceData();
      this.isLoading = true;
      this.$http
        .post(ROUTES.DASHBOARD.CONFIG_DEVICES.SAVE_DEVICE, obj)
        .then(({ data }) => {
          if (data.code > 0) {
            this.toast(
              "Se han guardado correctamente los cambios",
              TOAST_TYPES.SUCCESS
            );
            this.closeModal();
            this.$emit("updatedDevice", obj);
            return;
          }
          this.toast(
            "Lo sentimos, se ha producido un error",
            TOAST_TYPES.ERROR
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    autoSelectActivities() {
      this.moduleGroups.forEach((group) => {
        group.activities = group.activities.map((activity) => {
          const exist = this.deviceActivities.find((deviceActivity) => {
            const value = deviceActivity.purchasedModule
              ? JSON.parse(deviceActivity.purchasedModule)
              : null;

            const equalDinamicItemCode =
              value != null &&
              (deviceActivity.activity.app === activity.app ||
                (activity.originalActivity &&
                  deviceActivity.activity.app ===
                    activity.originalActivity.app)) &&
              value.find(
                (item) =>
                  item.codeListItem == activity.code &&
                  item.keyListName == activity.keyListName &&
                  item.listNameType == activity.listNameType &&
                  item.enable
              );
            return equalDinamicItemCode;
          });
          if (exist) {
            const purchasedModule = JSON.parse(exist.purchasedModule);
            const attrsActivity = purchasedModule.find(
              (pm) => pm.codeListItem == activity.code
            );
            activity.selected = attrsActivity.selected;
            activity.activated = activity.actionType != "GE";
            activity.saved = true;
            group.activated = true;
            group.selected = true;
          }
          return activity;
        });

        const allActived = group.activities.filter((a) => {
          return a.actionType === "GE" && a.selected;
        });
        if (allActived.length > 0) {
          group.activated = true;
          group.activities = group.activities.map((item) => ({
            ...item,
            activated: true,
          }));
        }
      });
    },
    findDeviceActivities() {
      const deviceId = this.deviceId;
      this.loadingModules = true;
      this.isLoading = true;
      this.$http
        .get(
          `${ROUTES.DASHBOARD.CONFIG_DEVICES.GET_DEVICES_ACTIVED}?deviceId=${deviceId}`
        )
        .then(({ data }) => {
          if (data.code > 0) {
            this.deviceActivities = data.info;
            this.autoSelectActivities();
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingModules = false;
        });
    },
    openModal() {
      this.show = true;
    },
    closeModal() {
      this.deviceId = null;
      this.show = false;
      this.company = null;
      this.deviceName = null;
      this.imei = null;
      this.deviceTetch = null;
      this.graceTime = null;
      this.technology = null;
      this.initialValue = null;
      this.resolution = null;
      this.moduleGroups = [];
      this.deviceActivities = [];
    },
  },
};
</script>

<style>
.modal-widget {
  background-color: #ffffff;
  border-radius: 5px;
  height: auto;
  margin: 0 auto;
  padding: 15px;
}
.modal-widget .btn-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 0;
  box-shadow: none;
  font-size: 1.2em;
  background-color: #f64651;
  color: #ffffff;
}
.modal-widget .btn-close:hover {
  background-color: black;
  color: #ffffff;
}
.modal-widget .modal-title {
  display: block;
  height: 25px;
  text-align: left;
  padding: 10px 15px;
  padding-bottom: 30px;
}
.modal-widget .modal-title .title {
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
}
.modal-widget .modal-body {
  display: block;
}
.group-container .group-header {
  padding: 5px 0px;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
}
.checkbox-item {
  padding: 5px 0;
}
.checkbox-item span {
  font-weight: bold;
}
.checkbox-item .vs-checkbox {
  border-color: #1d76fb !important;
}
.columns.device-modules {
  flex-direction: column;
  border-radius: 5px;
  justify-content: center;
  border: 1px solid #e6e6e6;
  background-color: #fafafa;
  margin-bottom: 15px;
  min-height: 300px;
}
.columns.device-modules .container {
  flex-direction: column;
}
.columns.device-modules .activities-container {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  padding: 0 20px;
}
.columns.device-modules .con-slot-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 25px);
}
.input-search {
  max-width: 300px;
}
.group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ececec;
  border: 1px solid #dadada;
  padding: 5px 5px !important;
}
.group-header .options {
  margin-left: 5px;
}
.btn-add-discount {
  margin-right: 5px;
}
.btn-option {
  width: 30px !important;
  height: 30px !important;
}
</style>
